import { useState } from 'react';
import APIUtil from '../../api/APIUtil';
import { Action as AdvisoryAction, PurchaseAction } from '../../global-types/AdvisoryContent';
import './Action.css';
import { getIconSizing } from './IconSize';

type ActionProps = {
  action: AdvisoryAction;
  dispatchActionEvent: (action: AdvisoryAction) => void;
  hasLoader?: boolean;
};

function Action({ action, dispatchActionEvent, hasLoader }: ActionProps) {
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<boolean>(false);

  async function handleOnClick(action: AdvisoryAction) {
    setLoading(true);
    setError(false);

    if (action.callback) {
      const responseCode = await APIUtil.handleCallback(`${action.callback.baseUrl}${action.callback.callbackPath}`, action.callback.payload);

      if (!responseCode || responseCode > 299) {
        setLoading(false);
        setError(true);
        return;
      }
    }
    dispatchActionEvent(action);
    setLoading(false);
  }

  if (action.url) {
    return (
      <div className="action">
        <a
          key={action.text}
          className={action.classNames}
          href={action.url}
          target={action.target ?? '_self'}
          onClick={() => handleOnClick(action)}
        >
          {action.text}
          {action.idsIconName && action.idsIconGroup && (
            <ids-icon {...{
              [action.idsIconName]: true,
              [`${action.idsIconGroup}-${getIconSizing(action.classNames)}`]: true
            }} />
          )}
        </a>
      </div>
    );
  } else {
      return (
        <>
          {error && (action as PurchaseAction).purchaseUnhandledErrorMessage && (
            <span className="if error-message advisory-mb-8">
              {(action as PurchaseAction).purchaseUnhandledErrorMessage}
            </span>
          )}
          <div className="action">
            <button
              type="button"
              className={action.classNames}
              onClick={() => handleOnClick(action)}
              disabled={hasLoader && loading}
            >
              {action.text}
              {action.idsIconName && action.idsIconGroup && (
                <ids-icon {...{
                  [action.idsIconName]: true,
                  [`${action.idsIconGroup}-${getIconSizing(action.classNames)}`]: true
                }} />
              )}
              {hasLoader && loading && (
                <span className="if loader dots x-small" />
              )}
            </button>
          </div>
        </>
    );
  }
};

export default Action;